document.addEventListener('DOMContentLoaded', () => {
  setWhy5iveHeaderHeight();
  initWhy5iveSections();
});

window.addEventListener('load', () => {
  setWhy5iveHeaderHeight();

  document.querySelectorAll('[data-why-5ive]').forEach((section) => {
    updateWhy5iveState(section);
  });
});

window.addEventListener(
  'resize',
  debounceWhy5ive(() => {
    setWhy5iveHeaderHeight();

    document.querySelectorAll('[data-why-5ive]').forEach((section) => {
      updateWhy5iveState(section);
    });
  }, 100)
);

document.addEventListener('shopify:section:load', (event) => {
  setWhy5iveHeaderHeight();

  const section = event.target.querySelector('[data-why-5ive]');

  if (section) {
    initWhy5ive(section);
  }
});

/* =========================
   HEADER HEIGHT
========================= */

function setWhy5iveHeaderHeight() {
  const header = document.querySelector(
    '.custom-header.custom-header--fixed'
  );

  if (!header) {
    document.documentElement.style.setProperty(
      '--home-why-header-height',
      '0px'
    );

    return;
  }

  const headerHeight = header.getBoundingClientRect().height;

  document.documentElement.style.setProperty(
    '--home-why-header-height',
    `${headerHeight}px`
  );
}

/* =========================
   INITIALIZE SECTIONS
========================= */

function initWhy5iveSections() {
  document.querySelectorAll('[data-why-5ive]').forEach((section) => {
    initWhy5ive(section);
  });
}

/* =========================
   INITIALIZE SLIDER
========================= */

function initWhy5ive(section) {
  if (section.dataset.whyInitialized === 'true') {
    return;
  }

  const slider = section.querySelector('[data-why-slider]');

  const cards = Array.from(
    section.querySelectorAll('[data-why-card]')
  );

  const prevButton = section.querySelector('[data-why-prev]');
  const nextButton = section.querySelector('[data-why-next]');

  if (!slider || cards.length === 0) {
    return;
  }

  section.dataset.whyInitialized = 'true';

  section._whyCards = cards;
  section._whySlider = slider;

  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let dragDistance = 0;
  let activePointerId = null;

  /* =========================
     CARD POSITION
  ========================= */

  const getCardStep = () => {
    if (cards.length < 2) {
      return cards[0].getBoundingClientRect().width;
    }

    const firstRect = cards[0].getBoundingClientRect();
    const secondRect = cards[1].getBoundingClientRect();

    return secondRect.left - firstRect.left;
  };

  /* =========================
     ARROW SCROLL
  ========================= */

  const scrollByCard = (direction) => {
    const step = getCardStep();

    slider.scrollBy({
      left: step * direction,
      behavior: 'smooth'
    });
  };

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      scrollByCard(-1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      scrollByCard(1);
    });
  }

  /* =========================
     NATIVE SCROLL TRACKING
  ========================= */

  slider.addEventListener(
    'scroll',
    () => {
      requestAnimationFrame(() => {
        updateWhy5iveState(section);
      });
    },
    {
      passive: true
    }
  );

  /* =========================
     DESKTOP MOUSE DRAG ONLY

     Touch is intentionally NOT
     handled here.

     Mobile/tablet uses native
     browser touch scrolling.
  ========================= */

  slider.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') {
      return;
    }

    if (event.button !== 0) {
      return;
    }

    isDragging = true;

    activePointerId = event.pointerId;

    startX = event.clientX;
    startScrollLeft = slider.scrollLeft;
    dragDistance = 0;

    slider.classList.add('is-dragging');

    try {
      slider.setPointerCapture(event.pointerId);
    } catch (error) {
      /* Pointer capture unavailable. */
    }
  });

  slider.addEventListener('pointermove', (event) => {
    if (!isDragging) {
      return;
    }

    if (
      activePointerId !== null &&
      event.pointerId !== activePointerId
    ) {
      return;
    }

    const difference = event.clientX - startX;

    dragDistance = Math.max(
      dragDistance,
      Math.abs(difference)
    );

    slider.scrollLeft =
      startScrollLeft - difference;
  });

  slider.addEventListener('pointerup', (event) => {
    if (!isDragging) {
      return;
    }

    finishWhy5iveMouseDrag(
      section,
      slider,
      event,
      activePointerId
    );

    isDragging = false;
    activePointerId = null;
  });

  slider.addEventListener('pointercancel', (event) => {
    if (!isDragging) {
      return;
    }

    finishWhy5iveMouseDrag(
      section,
      slider,
      event,
      activePointerId
    );

    isDragging = false;
    activePointerId = null;
  });

  /*
   * Prevent accidental card clicks
   * after desktop mouse dragging.
   */

  slider.addEventListener(
    'click',
    (event) => {
      if (dragDistance <= 8) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      dragDistance = 0;
    },
    true
  );

  updateWhy5iveState(section);
}

/* =========================
   FINISH DESKTOP DRAG
========================= */

function finishWhy5iveMouseDrag(
  section,
  slider,
  event,
  pointerId
) {
  slider.classList.remove('is-dragging');

  if (
    pointerId !== null &&
    slider.hasPointerCapture(pointerId)
  ) {
    try {
      slider.releasePointerCapture(pointerId);
    } catch (error) {
      /* Pointer capture already released. */
    }
  }

  snapWhy5iveToClosest(section);
}

/* =========================
   SNAP DESKTOP DRAG
========================= */

function snapWhy5iveToClosest(section) {
  const slider = section._whySlider;
  const cards = section._whyCards;

  if (!slider || !cards || cards.length === 0) {
    return;
  }

  const closestIndex = getClosestWhy5iveIndex(
    slider,
    cards
  );

  scrollToWhy5iveCard(
    slider,
    cards[closestIndex]
  );
}

/* =========================
   CLOSEST CARD
========================= */

function getClosestWhy5iveIndex(slider, cards) {
  const sliderRect = slider.getBoundingClientRect();

  let closestIndex = 0;
  let closestDistance = Infinity;

  cards.forEach((card, index) => {
    const cardRect = card.getBoundingClientRect();

    const distance = Math.abs(
      cardRect.left - sliderRect.left
    );

    if (distance < closestDistance) {
      closestDistance = distance;
      closestIndex = index;
    }
  });

  return closestIndex;
}

/* =========================
   SCROLL TO CARD
========================= */

function scrollToWhy5iveCard(slider, card) {
  if (!slider || !card) {
    return;
  }

  const sliderRect = slider.getBoundingClientRect();
  const cardRect = card.getBoundingClientRect();

  const targetScrollLeft =
    slider.scrollLeft +
    cardRect.left -
    sliderRect.left;

  slider.scrollTo({
    left: targetScrollLeft,
    behavior: 'smooth'
  });
}

/* =========================
   COUNTER + PROGRESS
========================= */

function updateWhy5iveState(section) {
  const slider =
    section._whySlider ||
    section.querySelector('[data-why-slider]');

  const cards =
    section._whyCards ||
    Array.from(
      section.querySelectorAll('[data-why-card]')
    );

  if (!slider || cards.length === 0) {
    return;
  }

  const current = section.querySelector(
    '[data-why-current]'
  );

  const total = section.querySelector(
    '[data-why-total]'
  );

  const progress = section.querySelector(
    '[data-why-progress]'
  );

  const prevButton = section.querySelector(
    '[data-why-prev]'
  );

  const nextButton = section.querySelector(
    '[data-why-next]'
  );

  const closestIndex = getClosestWhy5iveIndex(
    slider,
    cards
  );

  /* Counter */

  if (current) {
    current.textContent = String(
      closestIndex + 1
    ).padStart(2, '0');
  }

  if (total) {
    total.textContent = String(
      cards.length
    ).padStart(2, '0');
  }

  /* Progress */

  const maxScroll =
    slider.scrollWidth -
    slider.clientWidth;

  if (progress) {
    const initialPercentage =
      100 / cards.length;

    let percentage =
      initialPercentage;

    if (maxScroll > 0) {
      const scrollRatio =
        slider.scrollLeft / maxScroll;

      percentage =
        initialPercentage +
        scrollRatio *
          (100 - initialPercentage);
    }

    percentage = Math.max(
      initialPercentage,
      Math.min(100, percentage)
    );

    progress.style.width =
      `${percentage}%`;
  }

  /* Arrow state */

  const tolerance = 3;

  if (prevButton) {
    prevButton.disabled =
      slider.scrollLeft <= tolerance;

    prevButton.style.opacity =
      prevButton.disabled
        ? '0.35'
        : '1';

    prevButton.style.cursor =
      prevButton.disabled
        ? 'default'
        : 'pointer';
  }

  if (nextButton) {
    nextButton.disabled =
      slider.scrollLeft >=
      maxScroll - tolerance;

    nextButton.style.opacity =
      nextButton.disabled
        ? '0.35'
        : '1';

    nextButton.style.cursor =
      nextButton.disabled
        ? 'default'
        : 'pointer';
  }
}

/* =========================
   DEBOUNCE
========================= */

function debounceWhy5ive(
  callback,
  delay
) {
  let timeout;

  return function () {
    clearTimeout(timeout);

    timeout = setTimeout(
      callback,
      delay
    );
  };
}